import { useEffect, useRef } from 'react'
import { useCopyFallback } from '@/lib/clipboard'
import { Button } from './button'
import {
  Dialog,
  DialogBody,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from './dialog'
import { Textarea } from './input'

/** Diálogo de respaldo de `copyText`: muestra el texto ya seleccionado para copiarlo con Ctrl+C. */
export function CopyFallbackHost() {
  const { text, label, close } = useCopyFallback()
  const ref = useRef<HTMLTextAreaElement>(null)

  useEffect(() => {
    if (text === null) return
    const id = setTimeout(() => {
      ref.current?.focus()
      ref.current?.select()
    }, 50)
    return () => clearTimeout(id)
  }, [text])

  return (
    <Dialog open={text !== null} onOpenChange={(open) => !open && close()}>
      <DialogContent size="md">
        <DialogHeader>
          <DialogTitle>{label ?? 'Copiá el texto a mano'}</DialogTitle>
          <DialogDescription>
            Tu navegador no permitió copiar automáticamente. Seleccioná el texto y copialo con Ctrl+C (⌘+C en
            Mac).
          </DialogDescription>
        </DialogHeader>
        <DialogBody>
          <Textarea
            ref={ref}
            readOnly
            value={text ?? ''}
            rows={Math.min(10, Math.max(3, (text ?? '').split('\n').length))}
            className="font-mono text-xs"
            onFocus={(e) => e.currentTarget.select()}
          />
        </DialogBody>
        <DialogFooter>
          <Button onClick={close}>Listo</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
